module.exports = __webpack_public_path__ + "img/user.99a16238.svg";